
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smartphone/[slug]/tips/[article]",
      function () {
        return require("private-next-pages/smartphone/[slug]/tips/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smartphone/[slug]/tips/[article]"])
      });
    }
  